// This button shows a list of the customers that ordered a specific item per location.
// When clicked it list out all the customers and how much of the item they ordered.
// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";

export default function CustomersOrderedItem({ food, selectAll }) {
  const [open, setOpen] = useState(false);

  // ✅ Open/close based on selectAll
  useEffect(() => {
    setOpen(selectAll);
  }, [selectAll]);

  function toRoman(num) {
    const roman = [
      ["M", 1000],
      ["CM", 900],
      ["D", 500],
      ["CD", 400],
      ["C", 100],
      ["XC", 90],
      ["L", 50],
      ["XL", 40],
      ["X", 10],
      ["IX", 9],
      ["V", 5],
      ["IV", 4],
      ["I", 1],
    ];
    let result = "";
    for (const [letter, value] of roman) {
      while (num >= value) {
        result += letter;
        num -= value;
      }
    }
    return result;
  }

  return (
    <div className="Customers-Per-Item">
      {!selectAll && (
        <Button
          size="small"
          color="primary"
          variant="contained"
          onClick={() => setOpen(!open)}
        >
          CUSTOMERS
        </Button>
      )}
      {open && (
        <div>
          {Object.keys(food.customers).map((customerName, custIndex) => {
            // Split the name by dashes
            const nameParts = customerName.split("-");

            // Take only the first two parts (e.g., "Chris" and "Fake")
            const readableName = nameParts.slice(0, 2).join(" ");
            return (
              <p
                key={custIndex}
                style={{ margin: "2px 0", marginLeft: "60px" }}
              >
                {toRoman(custIndex + 1)}. {readableName}{" "}
                {food.individualDescription}{" "}
                <u style={{ color: "red" }}>x{food.customers[customerName]}</u>
              </p>
            );
          })}
        </div>
      )}
    </div>
  );
}
